import React from 'react';
import CaseGenerator from "../../../CaseGenerator/CaseGenerator";
import {CaseForms} from "../../../../helpers/enums";

import './RichiediInformazioniCase.scss';

const RichiediInformazioniCase = () => (
  <div className="RichiediInformazioniCase" data-testid="RichiediInformazioniCase">
    <CaseGenerator type={CaseForms.RichiediInformazioni}/>
  </div>
);

export default RichiediInformazioniCase;
